<telxl-button
    colour="light"
    (buttonClick)="onAttachClick()"
    (keydown.enter)="onAttachClick()"
>
    <i class="fa-solid fa-paperclip"></i>
    {{ buttonLabel() }}
</telxl-button>
